<template>
  <div class="actTabs">
    <template v-for="item in routerLink">
      <router-link
        :key="item.path"
        :to="{ path: item.path }"
        v-if="curActivityId != '0'"
        >{{ item.name }}</router-link
      >
    </template>
    <!-- <router-link to="/DetpActivity/ActivityInfo">基本信息</router-link>
    <template v-if="curActivityId != '0'">
      <router-link to="/DetpActivity/ActivityRegList">报名信息</router-link>
      <router-link to="/DetpActivity/ActivityDisposition">配置项</router-link>
    </template>     -->
  </div>
</template>

<script>
import store from '@/store'
export default {
  data() {
    return {
      routerLink: [
        { type: 'add', name: '基本信息', path: '/DetpActivity/ActivityInfo' },
        {
          type: 'update',
          name: '报名信息',
          path: '/DetpActivity/ActivityRegList',
        },
        {
          type: 'update',
          name: '配置项',
          path: '/DetpActivity/ActivityConfig',
        },
      ],
      curActivityId: store.getters.getCurActivityId, // 活动ID
    }
  },
  methods: {},
  mounted() {
    // console.log('store.getters.getCurActivityId', store.getters.getCurActivityId)
  },
}
</script>

<style lang="scss" scoped>
.actTabs {
  margin-bottom: 20px;
  a {
    font-size: 16px;
    color: #606266;
    padding: 10px 10px;
    border-bottom: 2px solid #ccc;
    display: inline-flex;
    margin-right: 15px;
  }
  .router-link-exact-active {
    font-size: 16px;
    color: #409eff;
    border-bottom: 2px solid #409eff;
  }
}
</style>
